import { extractKeys, getActionType, requestPromise } from './helpers';
import { List } from 'immutable';
import _ from 'lodash';

// Actions
const createAction = (actionType, payload) => {
    return {
        type: actionType,
        payload: payload,
    };
};

const requestPayload = customPayload => {
    const payload = {
        isFetching: true,
        finishedFetching: false,
    };
    return _.merge(payload, customPayload || {});
};

const successPayload = success => {
    const payload = {
        isFetching: false,
        finishedFetching: true,
    };
    return _.merge(payload, success);
};

const errorPayload = error => {
    const payload = {
        isFetching: false,
        finishedFetching: true,
    };
    return _.merge(payload, error.response);
};

const createAsyncAction = (getConf, endpoint, types, namespace, action) => {
    return args => {
        return dispatch => {
            const body = action.request.body;
            const customPayload = _.omit(args, body);
            const payload = Object.assign({}, requestPayload(action.customPayload), customPayload);

            const requestAction = createAction(
                getActionType(namespace, endpoint, types.get(0)),
                payload
            );
            dispatch(requestAction);
            const promiseFactory = requestPromise(getConf, action);
            const successHandler = action.response.success;
            const errorHandler = action.response.failure;
            promiseFactory(args).then(
                success => {
                    const successAction = createAction(
                        getActionType(namespace, endpoint, types.get(1)),
                        successPayload(success)
                    );
                    dispatch(successAction);
                    successHandler(dispatch, success, args);
                },
                error => {
                    if (error.response) {
                        error.response.json().then(function(json) {
                            error.response = json;
                            const errorAction = createAction(
                                getActionType(namespace, endpoint, types.get(2)),
                                errorPayload(error)
                            );
                            dispatch(errorAction);
                            errorHandler(dispatch, error, args);
                        });
                    } else {
                        error.response = { errors: { server: ['internal server error'] } };
                        const errorAction = createAction(
                            getActionType(namespace, endpoint, types.get(2)),
                            errorPayload(error)
                        );
                        dispatch(errorAction);
                        errorHandler(dispatch, error, args);
                    }
                }
            );
        };
    };
};

const actionCreators = (conf, endPoints) => {
    const actionsForNamespaces = {};
    const namespaces = extractKeys(endPoints);
    namespaces.forEach(namespace => {
        const actionForEndPoints = {};
        const endPointsForNamespace = extractKeys(endPoints[namespace]);
        endPointsForNamespace.forEach(endpoint => {
            const list = List.of('REQUEST', 'SUCCESS', 'FAILED');
            actionForEndPoints[endpoint] = createAsyncAction(
                conf,
                endpoint,
                list,
                namespace,
                endPoints[namespace][endpoint]
            );
        });
        actionsForNamespaces[namespace] = actionForEndPoints;
    });
    return actionsForNamespaces;
};

export default actionCreators;
